<template>
  <div>
    <el-form :inline="true" :model="query" class="demo-form-inline" size="small">
      <el-form-item label="成本科室">
        <el-input clearable v-model="query.checkDeskName" placeholder="成本科室"></el-input>
      </el-form-item>
      <el-form-item label="地址">
        <el-input clearable v-model="query.address" placeholder="地址"></el-input> </el-form-item><el-form-item
        label="负责人">
        <el-input clearable v-model="query.principalUser" placeholder="负责人"></el-input> </el-form-item><el-form-item
        label="手机号码">
        <el-input clearable v-model="query.phone" placeholder="手机号码"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button plain @click="reset" icon="el-icon-circle-close">重置</el-button>
        <el-button type="primary" plain @click="onSubmit" icon="el-icon-search">搜索</el-button>
      </el-form-item>
    </el-form>
    <!-- 操作 -->
    <Row :gutter="8" style="margin: 10px 0; width: 100%" v-if="actions && actions.length > 0">
      <div v-for="(v, k) in actions" :key="k" style="display: inline-flex">
        <Button style="margin-right: 10px" :size="v.size || 'default'" :type="v.type || 'warning'" :icon="v.icon || ''"
          @click="v.onClick">{{ v.label }}
        </Button>
      </div>
    </Row>
    <div class="rule_box">
      <el-table v-loading="loading" :data="data" style="width: 100%; margin-bottom: 20px" row-key="id" border stripe
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }" class="my-table">
        <el-table-column align="left" prop="index" label="序号" width="100" height="200">
        </el-table-column>
        <el-table-column align="left" prop="checkDeskName" label="成本科室">
        </el-table-column>
        <el-table-column align="center" prop="address" label="地址"> </el-table-column>
        <el-table-column align="center" prop="principalUser" label="负责人">
        </el-table-column>
        <el-table-column align="center" prop="phone" label="手机号码"> </el-table-column>
        <el-table-column fixed="right" label="操作" width="150" align="center">
          <template slot-scope="scope">
            <el-button type="text" text @click="toEdit(scope.row)" style="margin-right: 5px">编辑</el-button>
            <Space wrap>
              <Poptip width="200" confirm title="确定要删除这条数据吗?" @on-ok="onDel(scope.row)" @on-cancel="cancel" ok-text="确定"
                cancel-text="取消">
                <el-button type="text" text @click="toEdit(scope.row)" style="margin-right: 5px">删除</el-button>
              </Poptip>
            </Space>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
        :page-size="pageSize" layout="total, prev, pager, next" :total="total">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import baseList from "@/views/components/base/baseList.vue";
import AddAndEdit from "./addedit.vue";
import ImportTemplate from "@/views/components/common/form/checkDeskTemplate.vue";
import config from "@/../config";

export default {
  extends: baseList,
  components: { AddAndEdit },
  data() {
    return {
      value: "1",
      query: {
        checkDeskName: "",
        address: "",
        principalUser: "",
        phone: "",
      },
      loading: false,
      total: 0,
      pageNum: 1,
      pageSize: 10,
      pageSizeOpts: [10, 20, 30, 50, 100, 200, 500],
      actions: [
        {
          label: "新增",
          icon: "md-add",
          onClick: this.toAdd,
          type: "info",
        },
        {
          label: "下载模板",
          icon: "md-log-out",
          onClick: this.toDownload,
          type: "info",
        },
        {
          label: "导入科室",
          icon: "md-cloud-upload",
          onClick: this.toImport,
          type: "info",
        },
      ],
      data: [],
      expandedRowKeys: [],
      loading: false,
    };
  },
  created() {
    this.getCheckDeskList();
  },
  methods: {
    async onSubmit() {
      const isQueryEmpty = Object.values(this.query).every((value) => !value);
      if (isQueryEmpty) {
        return;
      }
      this.loading = true;
      try {
        this.pageNum = 1; // 重置为第一页
        let res = await $utils.api.load(
          "admin/system/check/listNoChild",
          {
            ...this.query, // 搜索条件
            pageNum: this.pageNum, // 分页参数
            pageSize: this.pageSize,
          },
          "get"
        );
        if (res.code === 200) {
          this.total = res.total;
          const addIndex = (data, startIndex) => {
            return data.map((item, index) => {
              let newItem = {
                ...item,
                index: startIndex + index + 1,
              };
              if (newItem.children && newItem.children.length > 0) {
                newItem.children = addIndex(newItem.children, startIndex);
              }
              return newItem;
            });
          };
          this.data = addIndex(res.rows, 0);
          this.loading = false;
        }
      } catch (error) {
        console.error("加载数据失败:", error);
      }
    },
    getParentIndex(index) {
      let parentIndex = 0;
      for (let i = 0; i <= index; i++) {
        if (!this.data[i].parentId) {
          parentIndex++;
        }
      }
      return parentIndex;
    },
    async reset() {
      this.query = {
        checkDeskName: "",
        address: "",
        principalUser: "",
        phone: "",
      };
      this.pageNum = 1; // 重置为第一页
      await this.getCheckDeskList(); // 重新加载数据
    },
    // 获取表格数据
    async getCheckDeskList() {
      this.loading = true;
      let d = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      };
      try {
        let res = await $utils.api.load("admin/system/check/list", d, "get");
        if (res.code === 200) {
          this.total = res.total;
          const addIndex = (data, startIndex) => {
            return data.map((item, index) => {
              let newItem = {
                ...item,
                index: startIndex + index + 1,
              };
              if (newItem.children && newItem.children.length > 0) {
                newItem.children = addIndex(newItem.children, startIndex);
              }
              return newItem;
            });
          };
          this.data = addIndex(res.rows, 0);
          this.loading = false;
        }
      } catch (error) {
        console.error("加载数据失败:", error);
      }
    },
    handleSizeChange(e) {
      this.pageSize = e;
      this.pageNum = 1;
      this.getCheckDeskList();
    },
    handleCurrentChange(e) {
      this.pageNum = e;
      this.getCheckDeskList();
    },
    async onDel(params) {
      let q = {};
      let res = await $utils.api.load(`/admin/system/check/${params.id}`, q, "DELETE");
      if (res.code == 200) {
        $utils.toast.success("删除成功");
        $utils.url.go(0);
      }
    },
    toEdit(currentRow) {
      this.$Modal.success({
        closable: true,
        width: "600px",
        title: "编辑核算科室信息",
        height: "80px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <div>
              <AddAndEdit
                onOnCancel={() => {
                  this.onCancel();
                }}
                type="edit"
                id={currentRow.id}
              />
            </div>
          );
        },
      });
    },
    toAdd() {
      this.$Modal.success({
        closable: true,
        width: "600px",
        title: "新增核算科室信息",
        height: "80px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <div>
              <AddAndEdit
                onOnCancel={() => {
                  this.onCancel();
                }}
                type="add"
              />
            </div>
          );
        },
      });
    },
    //下载模板
    toDownload() {
      window.location.href = config.API_HOST + `/admin/system/check/template/download`;
    },
    //导入
    toImport() {
      this.$Modal.success({
        closable: true,
        title: "导入科室",
        width: "1200px",
        height: "900px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <ImportTemplate
              style={{ margin: "0", color: "#19be6b" }}
              refListTable={() => {
                this.getCheckDeskList();
              }}
            ></ImportTemplate>
          );
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
/deep/.el-form-item {
  margin-bottom: 0 !important;
}

/deep/.el-pagination {
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}

/deep/ .active {
  background-color: transparent !important;
}

/deep/.my-table .el-table__body>tr>td {
  height: 48px;
}
</style>
